// src/app/components/foundation/PageHeader.tsx
import type { ReactNode } from 'react';
import clsx from 'clsx';

export interface PageHeaderProps {
  /** Page title, rendered as the page's <h1>. */
  title: ReactNode;
  /** Optional supporting copy under the title. */
  description?: ReactNode;
  /** Optional actions rendered inline with the title (buttons, links). */
  actions?: ReactNode;
  className?: string;
}

/**
 * Top-of-page heading block: title + optional description + inline
 * actions. Generic across features — no feature-specific copy lives
 * here. Same contract as representative-admin's PageHeader.
 */
export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
  return (
    <div className={clsx('flex flex-col gap-2', className)}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-lg font-semibold text-[var(--vania-text-primary,#f5f6f8)]">{title}</h1>
        {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
      </div>

      {description && (
        <p className="text-sm text-[var(--vania-text-secondary,#a6acb8)]">{description}</p>
      )}
    </div>
  );
}
